<template>
  <div id="trainer-education" class="mt-4">
    <h4 class="sub-title">Trainer Education</h4>
    <div id="course">
      <label for="course">Course Name</label>
      <b-form-input
        name="course"
        type="text"
        id="course"
        v-model="course_name"
      ></b-form-input>
    </div>
    <div id="date-completed" class="mt-4">
      <label for="date-completed">Date Completed</label>
      <b-form-input
        name="date-completed"
        type="date"
        id="date-completed"
        v-model="date_comp"
      ></b-form-input>
    </div>
    <div id="institution" class="mt-4">
      <label for="institution">Institution Name</label>
      <b-form-input
        name="institution"
        type="text"
        id="institution"
        v-model="institution"
      ></b-form-input>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainerEducation',
  computed: {
    course_name: {
      get() {
        return this.$store.state.trainers.trainer.course_name;
      },
      set(val) {
        this.$store.commit('trainers/course_name', val);
      },
    },
    date_comp: {
      get() {
        return this.$store.state.trainers.trainer.date_comp;
      },
      set(val) {
        this.$store.commit('trainers/date_comp', val);
      },
    },
    institution: {
      get() {
        return this.$store.state.trainers.trainer.institution;
      },
      set(val) {
        this.$store.commit('trainers/institution', val);
      },
    },
  },
};
</script>
